"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var FileList_1 = require("views/FileListOverview/FileList");
var ListHeader_1 = require("./ListHeader");
var ListRow_1 = require("./ListRow");
var translate_1 = require("utils/translate");
var download_1 = require("utils/download");
var Types = require("types");
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var sectionRoot = "".concat(ownProps.section, "Root");
    var sectionStatus = "".concat(ownProps.section, "Status");
    return {
        selectedLanguage: selectedLanguage,
        currentUser: state.auth.current,
        isMobile: state.viewport.size !== 'DESKTOP',
        root: state.bid.tender.documents[sectionRoot],
        status: state.bid.tender.documents[sectionStatus],
        documents: state.bid.tender.documents[ownProps.section],
        selectedDocuments: state.bid.tender.documents.selectedDocuments
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchFilesRequest: function (folder, section) {
        return dispatch(tenderActions.fetchFilesRequest(folder.id, tenderActions.sortByOptions, tenderActions.searchOptions, undefined, section));
    },
    downloadFolder: function (token) { return function (item) {
        var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
        var uuid = retVal.payload.uuid;
        (0, download_1.downloadFiles)(token, [item], undefined, undefined, function () {
            return dispatch(ToastActions.removeToast(uuid));
        });
    }; },
    toggleDocuments: function (item, status) {
        return dispatch(tenderActions.toggleDocuments(item, status));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('sortByOptions', 'setSortByOptions', tenderActions.sortByOptions), (0, recompose_1.withState)('allSelected', 'setAllSelected', false), (0, recompose_1.withState)('columns', 'setColumns', null), (0, recompose_1.withState)('sortby', 'setSortBy', 'asc'), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.root) {
            this.props.fetchFilesRequest(this.props.root, this.props.section);
            var meta = this.props.metaschema.find(function (x) { return x.identifier === 'name-meta'; });
            this.props.setSortByOptions(__assign(__assign({}, tenderActions.sortByOptions), { sortBy: (meta || {}).id || null }));
        }
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.root &&
            prevProps.root &&
            this.props.root.id !== prevProps.root.id) {
            this.props.fetchFilesRequest(this.props.root, this.props.section);
        }
        if (this.props.metaschema !== prevProps.metaschema ||
            this.props.sortByOptions.sortBy === '') {
            var meta = this.props.metaschema.find(function (x) { return x.identifier === 'name-meta'; });
            this.props.setSortByOptions(__assign(__assign({}, tenderActions.sortByOptions), { sortBy: (meta || {}).id || null }));
        }
        var items = this.props.items;
        if ((this.props.status !== prevProps.status &&
            this.props.status === 'FETCHED') ||
            this.props.sortByOptions !== prevProps.sortByOptions) {
            var sortedSchema = this.props.metaschema.sort(function (a, b) { return a.order - b.order; });
            items = (0, fileListFilter_1.filterData)(sortedSchema, this.props.documents, this.props.sortByOptions, tenderActions.searchOptions, sortedSchema);
            this.props.setItems(items);
        }
        if (items !== prevProps.items ||
            this.props.selectedDocuments !== prevProps.selectedDocuments) {
            this.props.setAllSelected(items.length > 0 &&
                items.every(function (r) {
                    return _this.props.selectedDocuments.findIndex(function (f) { return r.uuid === f.uuid; }) > -1;
                }));
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.root !== nextProps.root ||
            this.props.metaschema !== nextProps.metaschema ||
            this.props.allSelected !== nextProps.allSelected ||
            this.props.selectedDocuments !== nextProps.selectedDocuments ||
            this.props.sortByOptions !== nextProps.sortByOptions ||
            this.props.status !== nextProps.status ||
            this.props.documents !== nextProps.documents ||
            this.props.columns !== nextProps.columns ||
            this.props.items !== nextProps.items) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var EmptyContent = function (props) {
    if (props.root.perm === 0x00 && props.section !== 'reliablePartner') {
        return (React.createElement(components_1.EmptyFolder, { key: 'permission-denied', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-lock' }), title: '', content: '' }));
    }
    return (React.createElement(components_1.EmptyFolder, { key: 'empty-folder', title: (0, translation_1.getLocalization)('bid/tenderscard/nofiles/title'), content: (0, translation_1.getLocalization)('bid/tenderscard/nofiles/message') }));
};
var getPanelWithEmptyContent = function (props) { return (React.createElement(sok_ui_1.Panel, { icon: props.panelIcon, title: props.panelTitle, className: "tender-card-documents ".concat(props.section) },
    React.createElement("div", { className: "bid-tender-documents-container" },
        React.createElement(components_1.EmptyFolder, { key: "permission-denied", icon: React.createElement(sok_ui_1.Icon, { className: "fa-lock" }), title: "", content: "" })))); };
exports.default = enhance(function (props) {
    if (props.isContentLocked) {
        return getPanelWithEmptyContent(props);
    }
    return (React.createElement(sok_ui_1.Panel, { icon: props.panelIcon, title: props.panelTitle, className: "tender-card-documents ".concat(props.section) },
        React.createElement("div", { className: 'bid-tender-documents-container' },
            !props.root ||
                (props.status === 'FETCHING' && (React.createElement("div", { className: 'documents-loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null)))),
            props.root && props.status === 'FAILED' && (React.createElement("div", { className: 'documents-failed' },
                React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                            return props.root &&
                                props.fetchFilesRequest(props.root, props.section);
                        } })))),
            props.root &&
                props.status === 'FETCHED' &&
                props.documents.length > 0 && (React.createElement("div", { className: classNames('file-list-wrapper', props.section), style: {
                    minHeight: Math.min(props.items.length + 1, 10) * 50 + 20,
                    marginBottom: '1rem'
                } },
                React.createElement(FileList_1.FileList, { key: 'list', isMobile: props.isMobile, currentFolder: props.root, items: props.items, sortByOptions: props.sortByOptions, searchOptions: tenderActions.searchOptions, convert: function () { return false; }, downloadFolder: props.downloadFolder(props.currentUser.token), isAllBookmarked: false, onBookmarkClick: function () { return false; }, onUnBookmarkClick: function () { return false; }, onBookmarkAllFiles: function () { return false; }, staticIconCount: 4, staticIconCountMobile: 3, toggleItem: function (item) {
                        return props.toggleDocuments([item], !props.selectedDocuments.find(function (x) { return x.id === item.id; }));
                    }, onSelectAll: function () {
                        return props.toggleDocuments(props.items, !props.allSelected);
                    }, itemSelections: props.selectedDocuments, sortBy: function (sortBy, order) {
                        return props.setSortByOptions({
                            sortBy: sortBy,
                            order: order,
                            filters: props.sortByOptions.filters,
                            offset: props.sortByOptions.offset,
                            limit: props.sortByOptions.limit
                        });
                    }, isAllSelected: props.allSelected, baseUrl: props.baseUrl, metaDataColumns: props.metaschema, onSetColumnFilter: function (column, value) {
                        var f = __assign({}, props.sortByOptions.filters);
                        if (value === null) {
                            delete f[column];
                        }
                        else {
                            f[column] = value;
                        }
                        props.setSortByOptions({
                            sortBy: props.sortByOptions.sortBy,
                            order: props.sortByOptions.order,
                            offset: props.sortByOptions.offset,
                            limit: props.sortByOptions.limit,
                            filters: f
                        });
                    }, navigateTo: function () { return false; }, openNotificationsMenu: function () { return false; }, token: props.currentUser.token, ListHeader: ListHeader_1.ListHeader, ListRow: (0, ListRow_1.ListRow)(props.section), parentClass: props.section }))),
            props.root &&
                props.status === 'FETCHED' &&
                props.documents.length === 0 && (React.createElement(EmptyContent, { root: props.root, section: props.section })),
            props.section !== 'reliablePartner' && props.section !== 'tender' && (React.createElement("div", { className: 'documents-tools' },
                React.createElement(sok_ui_1.Button, { size: 'large', color: 'red', onClick: props.declineSection, disabled: props.disableButtons ||
                        props.status !== 'FETCHED' ||
                        !(props.root && props.root.perm > 0x00), text: (0, translation_1.getLocalization)('bid/tenderCard/decline') }),
                React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', onClick: props.approveSection, disabled: props.disableButtons ||
                        props.status !== 'FETCHED' ||
                        !(props.root && props.root.perm > 0x00), text: (0, translation_1.getLocalization)('bid/tenderCard/approve') }))))));
});
